import React from 'react';

const Card = ({ title, body }) => (
  <div style={{
    background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12,
    padding: '12px 14px',
  }}>
    <div style={{ fontWeight: 800, fontSize: 13, color: '#0f172a' }}>{title}</div>
    <div style={{ fontSize: 12, color: '#475569', lineHeight: 1.45, marginTop: 4 }}>{body}</div>
  </div>
);

/** One Help tab: how Time Tracker refuses to lose hours. */
export default function TimeTrackerSafetyNets() {
  return (
    <div style={{ padding: '4px 2px 8px' }}>
      <p style={{ margin: '0 0 14px', fontSize: 13, color: '#0f172a', lineHeight: 1.5, fontWeight: 600 }}>
        These are the standing rules. Not exceptions. Not a special job.
      </p>

      <div style={{ display: 'grid', gap: 10 }}>
        <Card
          title="Job plus discipline"
          body="Every extras list, op-code list, and timesheet dropdown is a job plus a discipline. Search the job number, pick the job, then pick PIP, MWR, ELE, and the rest. A job appears when it has that discipline on the project, or when the job number already ends in those three letters. Change Log extras land on that same pair. If you have not opened the pair, you have not opened the extra."
        />
        <Card
          title="Nothing is erased"
          body="Timesheets, op codes, extras, crews, crew members, and payroll periods are marked removed and hidden. The row stays. Accounting restores it from Audit. Re-adding the same extra, or saving Change Log again, also brings it back. Employees are deactivated. The master row stays for Accounting to keep current."
        />
        <Card
          title="Audit log"
          body="Daily and Weekly saves write the audit row in the same step as the hours, including room and board, meals, and travel. If that write fails, the hours are not kept. The log lives in the same database as the hours. Accounting restores a removed row from that screen."
        />
        <Card
          title="Period lock"
          body="The payroll group comes from the division name. A name that ends in (US) is the United States. A name that ends in (CA) is Canada. If the division does not say the country, or the person has no division, the week lock does not cover them. Do not lock while people are still entering hours."
        />
        <Card
          title="Azure holds the hours"
          body="The hours and the audit log live in Azure Database for PostgreSQL. Azure can restore the whole database to an earlier moment. A separate copy of the Time Tracker tables can be kept outside Azure, so the hours are not only inside that one database. That copy is not a button on this page. Git holds the code, not the hours."
        />
        <Card
          title="Dev first"
          body="Code and migrations land on the dev database first. Production is only touched on deploy. The employee master is Accounting’s book to keep updated. Developers do not invent Entra matches or payroll codes."
        />
      </div>
    </div>
  );
}
